import axios from 'axios';
import requests from '../util';
const { request } = requests;
const cancelTaskForMM = ({
  taskId
}) => {
  return request({
    url: '/api/v1/task/cancelTask',
    method: 'PATCH',
    body: { taskId }
  });
};

const cancelTaskApi = { cancelTaskForMM };

export default cancelTaskApi;
